import { customerTypesSlice } from "./customerTypesSlice";
import * as actions from "./customerTypesActions";
import * as selectors from "./customerTypesSelectors";

export { actions };
export { selectors };
export default customerTypesSlice.reducer;
